import {React} from '../utils/thirdpartyComponents'
const FullLoaderwithlocationfetch = () => {
  return (
    // <div className="cw-loader-overlay align-items-center flex-column justify-content-center">
        <div className="fetch-loader d-flex mt-2 justify-content-center"><p className='m-0'>Fetching your location</p><div className="dot-loader"></div></div>
    // </div>
  );
};

export default FullLoaderwithlocationfetch;
